import { render, staticRenderFns } from "./AlertStatsTable.vue?vue&type=template&id=92bacfc8&"
import script from "./AlertStatsTable.vue?vue&type=script&lang=js&"
export * from "./AlertStatsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports